import React from "react"
import { Row, Col } from "react-bootstrap";
import "./inc.css"
import { Link } from "react-router-dom";
import thehive from "../../Resources/CYS/theHive.png"
import gtf from "../../Resources/CYS/GTS01.png"


const CYS = () =>{
    return(
        <Row className="cys-body">
            <h2 className="cys-title">
                Connect your store
            </h2>
            <p className="cys-dscription">
                The Hive easily helps users connect to local e-commerce platforms and marketplaces in your area.
            </p>
            <Col sm={12} className="cys-stores">
                {/* css: position: abosulte {positions will be at randome for each store {left, right, top, bottom}} */}
                <Link className="cys-stores-connect">
                    <img src={thehive} alt="image of connected stores" />
                </Link>
                <Link className="cys-stores-connect">
                    <img src={gtf} alt="image of connected stores" />
                </Link>
            </Col>
        </Row>
    )
}

export default CYS